import React from 'react';
import { ChevronLeft, ChevronRight, Grid3X3, Home } from 'lucide-react';
import { Button } from '../ui/button';
import { REVIEW_STATUS } from '../../constants';

const ReviewBottomNavigation = ({
  currentQuestionIndex,
  totalQuestions,
  questionLabel,
  onPrevious,
  onNext,
  onGoHome,
  onOpenNavigation,
  answerStatuses,
  rcContext,
  isFirstQuestion,
  isLastQuestion
}) => {
  const counts = {
    correct: 0,
    partial: 0,
    incorrect: 0,
    skipped: 0
  };

  answerStatuses?.forEach(({ status }) => {
    if (status === REVIEW_STATUS.CORRECT) counts.correct++;
    else if (status === REVIEW_STATUS.PARTIAL) counts.partial++;
    else if (status === REVIEW_STATUS.INCORRECT) counts.incorrect++;
    else if (status === REVIEW_STATUS.SKIPPED) counts.skipped++;
  });

  return (
    <div className="border-t border-border/50 bg-card px-4 pb-[calc(1rem+env(safe-area-inset-bottom,0px))] pt-4">
      <div className="mb-4 flex flex-wrap items-center justify-center gap-3 text-xs md:hidden">
        <div className="flex items-center gap-1">
          <div className="h-3 w-3 rounded-full bg-[#C0E281]" />
          <span className="text-muted-foreground">{counts.correct} Correct</span>
        </div>
        <div className="flex items-center gap-1">
          <div className="h-3 w-3 rounded-full bg-[#F3BB51]" />
          <span className="text-muted-foreground">{counts.partial} Partial</span>
        </div>
        <div className="flex items-center gap-1">
          <div className="h-3 w-3 rounded-full bg-[#EF8888]" />
          <span className="text-muted-foreground">{counts.incorrect} Incorrect</span>
        </div>
        <div className="flex items-center gap-1">
          <div className="h-3 w-3 rounded-full bg-[#EED68A]" />
          <span className="text-muted-foreground">{counts.skipped} Skipped</span>
        </div>
      </div>

      <div className="hidden gap-3 md:flex">
        <Button
          type="button"
          variant="outline"
          onClick={onPrevious}
          disabled={isFirstQuestion}
          className="min-w-0 flex-1 basis-0 border-primary/20 hover:border-primary/50"
        >
          Previous
        </Button>
        {isLastQuestion ? (
          <Button type="button" onClick={onGoHome} className="min-w-0 flex-1 basis-0">
            <Home className="h-4 w-4" />
            Home
          </Button>
        ) : (
          <Button type="button" onClick={onNext} className="min-w-0 flex-1 basis-0">
            Next
          </Button>
        )}
      </div>

      <div className="flex items-center gap-3 md:hidden">
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={onPrevious}
          disabled={isFirstQuestion}
          className="border-primary/20 px-3 hover:border-primary/50"
        >
          <ChevronLeft className="h-4 w-4" />
        </Button>

        <Button
          type="button"
          variant="outline"
          onClick={onOpenNavigation}
          className="flex h-auto flex-1 flex-col items-center justify-center gap-0.5 border-primary/20 py-2 hover:border-primary/50 hover:bg-primary/5"
        >
          <div className="flex items-center gap-2">
            <Grid3X3 className="h-4 w-4" />
            <span>
              {questionLabel
                ? `Question ${questionLabel} · ${currentQuestionIndex + 1} of ${totalQuestions}`
                : `Question ${currentQuestionIndex + 1} of ${totalQuestions}`}
            </span>
          </div>
          {rcContext && (
            <span className="text-xs text-muted-foreground">
              Part {rcContext.subIndex + 1} of {rcContext.totalSub}
            </span>
          )}
        </Button>

        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={isLastQuestion ? onGoHome : onNext}
          className="border-primary/20 px-3 hover:border-primary/50"
          aria-label={isLastQuestion ? 'Go to home' : 'Next question'}
        >
          {isLastQuestion ? <Home className="h-4 w-4" /> : <ChevronRight className="h-4 w-4" />}
        </Button>
      </div>
    </div>
  );
};

export default ReviewBottomNavigation;
